/* eslint-disable */
(function ChatBar() {
  window.addEventListener("load", (event) => {
    var data = JSON.parse(document.querySelector('[data-chat-config]').innerHTML);
    var $chatLink = document.querySelectorAll('[data-chat-trigger]');
    var chatIcons = document.querySelectorAll('#icon-chat');
    var chatSpinners = document.querySelectorAll('#icon-chat-spinner');
    var enableCustomAgentCheck = true;
    var adaChatOpened = false;

    if (typeof $chatLink !== 'undefined') {
      $chatLink.forEach(function (link) {
        link.addEventListener('click', chatLinkClick);
      });

      if (typeof window.Simba === 'object' && typeof window.Simba.Cookie === 'object' && typeof window.Simba.Cookie.read === 'function') {
        adaChatOpened = window.Simba.Cookie.read('ada-chat-opened');
      }

      if(data.show_chat || adaChatOpened === 'true') {
        clickChat($chatLink);
      }
    }

    function clickChat($chatLink) {
      if ($chatLink.length > 0) {
        $chatLink[0].click();
        setIcon('inline');
        setSpinner('none');
      }
    }

    function chatLinkClick(evt) {
      if (typeof evt !== 'undefined') evt.preventDefault();
      if(data.settings.chat_type == 'ada') {
        loadAdaChat();
      }
    }

    function loadAdaChat() {
      var $script = $('#__ada');
      if ($script.length == 0) {
        setIcon('none');
        setSpinner('inline');
        if (!document.getElementById('__ada')) {
          window.adaSettings = {
            toggleCallback: (isDrawerOpen) => {
              if (typeof window.Simba === 'object' && typeof window.Simba.Cookie === 'object' && typeof window.Simba.Cookie.create === 'function') {
                window.Simba.Cookie.create('ada-chat-opened', isDrawerOpen);
              }
            },
          }

          if (document.querySelector('[data-zendesk-locale]')) {
            var language = document.querySelector('[data-zendesk-locale]').getAttribute('data-zendesk-locale');
            window.adaSettings.language = language;
          }

          var script = document.createElement('script');
          script.id = '__ada';
          script.type = 'text/javascript';
          script.dataset.handle = "simba-sleep";
          script.src = 'https://static.ada.support/embed2.js';
          script.addEventListener('load', function () {
            onAdaChatLoaded();
          });
          document.body.appendChild(script);
        }
      } else {
        if (typeof window.adaEmbed !== 'undefined') {
          window.adaEmbed.toggle();
        }
      }
    }

    function onAdaChatLoaded() {
      setIcon('inline');
      setSpinner('none');

      if (!data.show_chat && adaChatOpened !== 'true' && typeof window.adaEmbed !== 'undefined') {
        window.adaEmbed.toggle();
      }
    }

    function setIcon(state) {
      chatIcons.forEach(function (icon) {
        icon.style.display = state;
      });
    }

    function setSpinner(state) {
      chatSpinners.forEach(function (spinner) {
        spinner.style.display = state;
      });
    }
  });
})();
